import { type AxiosResponse } from 'axios'
import api from '../utils/api'
interface GetTermByIdPayload {
  termId: string
}

interface UpdateTermPayload {
  termId: string | undefined
  payload: Record<string, any>
}

const getGlobalTermsListApi = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/terms/', {
    params,
    headers: {
      Accept: 'application/cdg'
    }
  })
}

const getReportsTermsList = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/terms/', { params })
}

const getTermById = async (payload: GetTermByIdPayload): Promise<AxiosResponse> => {
  return await api.get(`/api/terms/${payload.termId}`, {
    headers: {
      Accept: 'application/cdg'
    }
  })
}

const getAllTerms = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/terms/summary/', { params })
}

const createTerm = async (payload: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post('/api/terms/', payload)
}

const updateTerm = async (payload: UpdateTermPayload): Promise<AxiosResponse> => {
  return await api.patch(`/api/terms/${payload.termId}`, payload.payload)
}

const deleteTerm = async (termId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/terms/${termId}`)
}

const exportTermsCSV = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/terms/export/', { params })
}

const exportEnrollmentsCSV = async (termId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/terms/${termId}/enrollments/export/`, { params })
}

export const resetCourseSectionsByTermId = async (termId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/terms/${termId}/reset/sections/`)
}

export default {
  getGlobalTermsListApi,
  getReportsTermsList,
  createTerm,
  updateTerm,
  getAllTerms,
  deleteTerm,
  exportTermsCSV,
  exportEnrollmentsCSV,
  getTermById
}
